// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__2zNlf","center":"styles_center__1Aumy","sectionTitle":"styles_sectionTitle__3uT77","sectionSubtitle":"styles_sectionSubtitle__2k0d3"};